export enum LoanPropertyFileType {
    Budget = 0,
    SpecSheet = 1,
    Plans = 2,
    Survey = 3,
    GCResume = 4,
    PresaleContract = 5,
    CapitalExpenditures = 6,
    PurchaseContract = 7,
    Appraisal = 8,
    Other = 9,
    ProofOfOccupancy = 10,
}
